var map = {
	"./auth/actions.js": 3281,
	"./auth/getters.js": 8778,
	"./auth/mutations.js": 8010,
	"./auth/state.js": 59,
	"./delivery/actions.js": 7891,
	"./delivery/getters.js": 8272,
	"./delivery/mutations.js": 7624,
	"./delivery/state.js": 5785,
	"./index.js": 6515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4870;